import api from './base';

async function fetchTimeCharterRegions({type = 'mpp'} = {}) {
  return await api.call('prices/tcRatePrices', {type})
}

async function createTimeCharterRegion(data) {
  return await api.call('prices/tcRatePrice', data, 'post')
}

async function removeTimeCharterRegion(data) {
  return await api.call('prices/tcRatePrice', data, 'delete')
}

async function updateTimeCharterRegion(data) {
  return await api.call('prices/tcRatePrice', data, 'put')
}

async function recalculateTimeCharterRegion(id, data) {
  return await api.call(`prices/tcRatePrice/recalculate?id=${id}`, data, 'put')
}

export default {
  fetchTimeCharterRegions,
  createTimeCharterRegion,
  removeTimeCharterRegion,
  updateTimeCharterRegion,
  recalculateTimeCharterRegion
}


// WEBPACK FOOTER //
// ./app/services/timeCharters.js